"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _ActionAssetItem = _interopRequireDefault(require("../ActionAssetItem"));
var _events = require("../events");
var eventsUtils = _interopRequireWildcard(require("../../../utils/events"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "version-table-menu-item": "VersionsTableActions__version-table-menu-item__1gKla",
  "versionTableMenuItem": "VersionsTableActions__version-table-menu-item__1gKla",
  "version-table-popover-action": "VersionsTableActions__version-table-popover-action__gDLIa",
  "versionTablePopoverAction": "VersionsTableActions__version-table-popover-action__gDLIa"
}; 
require('./VersionsTableActions.css');
var VersionsTableActions = function VersionsTableActions(_ref) {
  var asset = _ref.asset,
    actions = _ref.actions,
    isStudio = _ref.isStudio,
    isEdit = _ref.isEdit,
    isDraft = _ref.isDraft,
    addRef = _ref.addRef;
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var compiledActions = _react.default.useMemo(function () {
    return actions({
      isStudio: isStudio,
      isEdit: isEdit,
      isDraft: isDraft,
      section: 'versions-table'
    });
  }, [actions, asset, isStudio, isEdit, isDraft, trackEvent]);
  var clickFns = _react.default.useMemo(function () {
    return compiledActions.map(function (action) {
      var actionId = action.id,
        href = action.href;
      return function () {
        var _action$onClick;
        (0, _events.trackGenericActionEvent)({
          asset: asset,
          actionId: actionId,
          section: 'versions-table',
          trackEvent: trackEvent
        });
        (_action$onClick = action.onClick) === null || _action$onClick === void 0 || _action$onClick.call(action);
        if (href) {
          global.open(href, '_blank');
        }
      };
    });
  }, [compiledActions]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, compiledActions.map(function (action, index) {
    var label = action.label,
      description = action.description,
      actionId = action.id,
      icon = action.icon,
      href = action.href;
    var key = "version-table-".concat(actionId);
    var onClick = clickFns[index];
    return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
      key: key,
      className: styles.versionTableMenuItem,
      onClick: onClick,
      onKeyDown: eventsUtils.onEnterKey(onClick),
      testId: key,
      tabIndex: "-1",
      getRef: function getRef(elem) {
        if (addRef) {
          addRef(elem, index);
        }
      }
    }, /*#__PURE__*/_react.default.createElement(_ActionAssetItem.default, {
      className: styles.versionTablePopoverAction,
      icon: icon,
      href: href,
      label: label,
      testId: "".concat(key, "-action-item"),
      description: description
    }));
  }));
};
var _default = exports.default = VersionsTableActions;
//# sourceMappingURL=VersionsTableActions.js.map